<template>
  <div class="team-page">
    <div class="tab-box">
      <ul class="tab-btn-list">
        <li v-for="(tab, index) in tabList" :key="index" :class="{active: tab.isActive}">
          <router-link :to="{name: tab.name}">
            {{tab.title}}
          </router-link>
        </li>
      </ul>
    </div>

    <div v-if="seasonType.teamRanking" class="container team-rank">
      <DateSlider :year-state="true" @year="yearChange" />
      <div class="ranking">
        <div class="rankingBox">
          <table>
            <thead>
            <tr v-if="isMobile">
              <th>순위</th>
              <th>팀</th>
              <th>승/무/패</th>
              <th>득점</th>
              <th>승점</th>
            </tr>
            <tr v-else>
              <th>순위</th>
              <th>팀</th>
              <th>승</th>
              <th>무</th>
              <th>패</th>
              <th>득점</th>
              <th>승점</th>
            </tr>
            </thead>
            <tbody v-if="listStatus">
            <tr  v-for="(team, index) in list" :key="index" :class="{ active: team.active }">
              <td class="rank">{{ team.rank }}</td>
              <td class="team">
                <img :src="getEmblem(team.team_id)">{{ team.team_name }}
              </td>
              <td v-if="isMobile" class="game">
                {{ team.win_cnt }}/{{ team.tie_cnt }}/{{ team.loss_cnt }}
              </td>
              <td v-if="!isMobile" class="game">
                {{ team.win_cnt }}
              </td>
              <td v-if="!isMobile" class="game">
                {{ team.tie_cnt }}
              </td>
              <td v-if="!isMobile" class="game">
                {{ team.loss_cnt }}
              </td>
              <td class="score">{{ team.gain_goal }}</td>
              <td class="point">{{ team.gain_point }}</td>
            </tr>

            </tbody>
            <tbody v-else>
            <tr>
              <td v-if="!isMobile" class="content-empty" colspan="7">
                <p>데이터가 없습니다</p>
              </td>
              <td v-else class="content-empty" colspan="5">
                <p>데이터가 없습니다</p>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-else>
      <PageComingSoon :titleText="' '" :descriptionText="String(seasonMsg)" />
    </div>
  </div>
</template>

<script>
import {sortData, getEmblem} from '@/lib';
import DateSlider from '@/components/Common/DateSlider.vue';
import dayjs from "dayjs";
import {matchTeamArea} from '@/lib/match'
import PageComingSoon from '@/components/Common/PageComingSoon';

export default {
  name: 'TeamRanking',
  components: {DateSlider, PageComingSoon},
  data() {
    return {
      tabList: [],
      isMobile: false,
      list: [],
      listStatus: false,
      meetYear: dayjs().format('YYYY'),
      seasonType: this.$store.getters['getSeasonType'],
      seasonMsg: this.$store.getters['getSeasonMsg'],
    }
  },
  created() {
    const menuList = this.$router.options.routes && this.$router.options.routes.filter(x => {
      return x.path === this.$route.matched[0].path ? x : '';
    });

    const subMenuList = menuList[0].children && menuList[0].children.filter(x => {
      return x.meta && x.meta.title;
    });

    Object.entries(subMenuList).forEach(([, value]) => {
      const result = {
        title: value.meta.title,
        name: value.name,
        isActive: this.$route.name === value.name ? true : false
      }
      this.tabList.push(result);
    });
  },
  mounted () {
    window.addEventListener('resize', this.onResize);
    this.$nextTick(() => {
      this.onResize()
    })
    this.getRanking();
  },
  methods: {
    getEmblem,
    async getRanking() {
      const {data} = await this.$http.get(`/game/rank?year=${this.meetYear}`);
      this.list = data.data.all_rank;
      this.listStatus = !!this.list;
      this.list?.map(item => {
        if(item.team_id === 'K07') {
          item.active = true;
        }
        item.team_name = matchTeamArea(item.team_id);
      })

    },
    onResize () {
      this.isMobile = window.innerWidth < 960
    },
    sortData,
    yearChange(data) {
      this.meetYear = data;
      this.getRanking();
    },
  }
}
</script>
<style scoped>
.content-empty p {
  font-size: 14px;
  font-weight: 300;
  color: #777;
}
</style>
